import type { SaleMode } from '@paulownia/shared/types';
import { SaleModeSelector } from '../SaleModeSelector';

interface WizardStepModeProps {
  saleMode?: SaleMode;
  onSaleModeChange: (mode: SaleMode) => void;
}

export function WizardStepMode({ saleMode, onSaleModeChange }: WizardStepModeProps) {
  return (
    <div className="space-y-4">
      <div className="text-center mb-6">
        <h2 className="text-lg font-semibold text-gray-900">Comment vendez-vous ce produit ?</h2>
        <p className="text-sm text-gray-500 mt-1">
          Choisissez le mode de vente qui correspond à votre produit.
        </p>
      </div>

      <SaleModeSelector
        value={saleMode}
        onChange={onSaleModeChange}
      />
    </div>
  );
}
